import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import { FaSpinner } from "react-icons/fa";
import "../css/form.css";

const MeterForm = () => {
  const navigate = useNavigate(); // Hook for navigation

  const [formData, setFormData] = useState({
    meterId: "",
    phoneno: "",
    email: "",
    location: "",
    estate: "",
    amount: "",
    callback_url: `${window.location.origin}/success`, // Set callback to success page
  });

  const [apiResponse, setApiResponse] = useState(null);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Form submit loading state
  const [isPaymentLoading, setIsPaymentLoading] = useState(false); // Payment button loading state

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission to fetch meter details
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
  
    const token = process.env.REACT_APP_AUTH_TOKEN || "NjNkOWZmNjQzMDc1M2EwOjI4N2FiM2NkNzkwYjhiMQ=="; // Retrieve token from env or default
    const requestBody = {
      meterId: formData.meterId,
      phoneno: formData.phoneno,
      email: formData.email,
      location: formData.location,
      estate: formData.estate,
      amount: formData.amount,
      callback_url: `${formData.callback_url}?email=${encodeURIComponent(formData.email)}&phoneno=${encodeURIComponent(formData.phoneno)}&estate=${encodeURIComponent(formData.estate)}&`,
    };
  
    // try {
    //   const response = await fetch("/api/method/blumenpay_vending.api.service.get_meter_info", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       "Authorization": `Basic ${token}`,
    //     },
    //     body: JSON.stringify(requestBody),
    //   });

      try {
        const apiUrl = `${process.env.REACT_APP_API_URL}/api/method/blumenpay_vending.api.service.get_meter_info`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Basic ${token}`,
          },
          body: JSON.stringify(requestBody),
        });

  
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        if (data.message) {
          setApiResponse(data.message);
          setShowModal(true);
          setError(null);
        } else {
          setError("Failed to fetch meter info.");
        }
      } else {
        const text = await response.text();
        console.error("Non-JSON response received:", text);
        setError("Server returned an unexpected response. Please contact support.");
      }
    } catch (error) {
      console.error("Error fetching meter info:", error);
      setError("An error occurred. Please try again.");
    }
  
    setIsLoading(false);
  };

  // Handle Payment Processing
  const handlePayment = async () => {
    setIsPaymentLoading(true);
  
    try {
      console.log("API Response:", apiResponse); // Debug the response
  
      // Validate the payment URL
      const rawPaymentUrl = apiResponse.payment_requets.payment_url;
      console.log("Raw Payment URL:", rawPaymentUrl);
  
      if (!rawPaymentUrl || typeof rawPaymentUrl !== "string") {
        throw new Error("Payment URL is missing or invalid.");
      }
  
      const sanitizedPaymentUrl = rawPaymentUrl.trim();
      const paymentUrl = new URL(sanitizedPaymentUrl);
  
      // Append the token as a query parameter
      const token = "NjNkOWZmNjQzMDc1M2EwOjI4N2FiM2NkNzkwYjhiMQ==";
      paymentUrl.searchParams.append("token", token);
  
      console.log("Redirecting to Payment URL:", paymentUrl.toString());
      window.location.href = paymentUrl.toString();
    } catch (error) {
      console.error("Error processing payment:", error);
      setError(error.message || "An error occurred while processing payment. Please try again.");
      setIsPaymentLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const paymentStatus = urlParams.get("status");
  //   const paymentReference = urlParams.get("reference");
  //   const email = urlParams.get("email");
  //   const phoneno = urlParams.get("phoneno");

  //   if (paymentStatus && ["success", "failed"].includes(paymentStatus)) {
  //     const callbackUrl = new URL(formData.callback_url);
  //     callbackUrl.searchParams.set("status", paymentStatus);
  //     if (paymentReference) {
  //       callbackUrl.searchParams.set("reference", paymentReference);
  //     }
  //     if (email) {
  //       callbackUrl.searchParams.set("email", email);
  //     }
  //     if (phoneno) {
  //       callbackUrl.searchParams.set("phoneno", phoneno);
  //     }
  //     window.location.href = callbackUrl.toString();
  //   } else if (paymentStatus) {
  //     setError("Invalid payment status received.");
  //   }
  // }, [formData.callback_url]);


  return (
    <div className="form-container paddng_form">
      <form className="payment-form" onSubmit={handleSubmit}>
        <h2>Meter Information Form</h2>
        <div className="form-group">
          <label htmlFor="meterId">Meter ID</label>
          <input
            type="text"
            id="meterId"
            name="meterId"
            value={formData.meterId}
            onChange={handleChange}
            placeholder="Enter meter ID"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneno">Phone Number</label>
          <input
            type="text"
            id="phoneno"
            name="phoneno"
            value={formData.phoneno}
            onChange={handleChange}
            placeholder="Enter phone number"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="location">Location</label>
          <select
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
          >
            <option value="" disabled>Select Location</option>
            <option value="Abuja">Abuja</option>
            <option value="Kaduna">Kaduna</option>
            <option value="Lagos">Lagos</option>
            <option value="Kano">Kano</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="estate">Estate</label>
          <select
            id="estate"
            name="estate"
            value={formData.estate}
            onChange={handleChange}
            required
          >
            <option value="" disabled>Select Estate</option>
            <option value="Grosolar Estate 1">GroSolar Estate 1</option>
            <option value="Grosolar Estate 2">GroSolar Estate 2</option>
            <option value="Grosolar Estate 3">GroSolar Estate 3</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="amount">Amount (₦)</label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            placeholder="Enter amount to pay"
            required
          />
        </div>
        <div className="button-container">
          <button type="submit" className="submit" disabled={isLoading}>
            {isLoading ? <FaSpinner className="spinner" /> : "Fetch Customer Info"}
          </button>
        </div>
        {error && <p className="error-message">{error}</p>}
      </form>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <h3>Customer Info</h3>
            <div className="info_content">
              <p><strong>Customer Name:</strong> {apiResponse.customer.customer_name}</p>
              <p><strong>Meter ID:</strong> {apiResponse.customer.custom_meter_id}</p>
              <p><strong>Meter Type:</strong> {apiResponse.customer.custom_meter_type}</p>
              <p><strong>Unit Price:</strong> ₦{apiResponse.customer.custom_price}</p>
              <p><strong>Amount to Pay:</strong> ₦{apiResponse.payment_requets.grand_total}</p>
              <div className="info_button">
                <p>{apiResponse.payment_requets.message}</p>
                <button onClick={handlePayment} className="info_submit" disabled={isPaymentLoading}>
                  {isPaymentLoading ? <FaSpinner className="spinner" /> : "Proceed to Pay"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MeterForm;
